import { all, call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { uploadFilesSaga } from '../upload/saga';
import {
    assignRedeemableCodeFail,
    assignRedeemableCodeSuccess,
    awardPrizeFail,
    awardPrizeSuccess,
    castVoteFail,
    castVoteSuccess,
    createAwardCategoryFail,
    createAwardCategorySuccess,
    createBookmarkFail,
    createBookmarkSuccess,
    createContestFail,
    createContestSuccess,
    createHostFail,
    createHostSuccess,
    createPartnerFail,
    createPartnerSuccess,
    createScoreCategoryFail,
    createScoreCategorySuccess,
    deleteBookmarkFail,
    deleteBookmarkSuccess,
    deleteContestFail,
    deleteContestSuccess,
    deleteHostFail,
    deleteHostSuccess,
    deletePartnerFail,
    deletePartnerSuccess,
    downloadAssetFail,
    downloadAssetSuccess,
    getAllPartnersFail,
    getAllPartnersSuccess,
    getAllSubmissionFail,
    getAllSubmissionSuccess,
    getAwardCategoriesForContestFail,
    getAwardCategoriesForContestSuccess,
    getBookmarkFail,
    getBookmarkSuccess,
    getContestAwardsFail,
    getContestAwardsSuccess,
    getContestFail,
    getContestReferencesFail,
    getContestReferencesSuccess,
    getContestSuccess,
    getContestsFail,
    getContestsSuccess,
    getHostFail,
    getHostSuccess,
    getMySubmissionsFail,
    getMySubmissionsSuccess,
    getPartnerFail,
    getPartnerSuccess,
    getRecommendationFail,
    getRecommendationSuccess,
    getRedeemableCodesFail,
    getRedeemableCodesSuccess,
    getS3imagesFail,
    getS3imagesSuccess,
    getUserContestFail,
    getUserContestSuccess,
    getUserContestsSuccess,
    getUserContestsFail,
    getUsersUnsubmittedProjectsFail,
    getUsersUnsubmittedProjectsSuccess,
    initaiet2FAForVoteFail,
    initaiet2FAForVoteSuccess,
    publishContestFail,
    publishContestSuccess,
    rescindSubmissionFail,
    rescindSubmissionSuccess,
    updateSubmissionFail,
    updateSubmissionSuccess,
    searchHostFail,
    searchHostSuccess,
    searchPartnerFail,
    searchPartnerSuccess,
    sendContestEmailFail,
    sendContestEmailSucess,
    sendWinnersEmailFail,
    sendWinnersEmailSucess,
    setCategoryForSubmission,
    setVoting2Fa,
    setVotingFlow,
    submitProjectFail,
    submitProjectSuccess,
    completeSubmissionPaymentSuccess,
    completeSubmissionPaymentFail,
    requestSubmissionPaymentSuccess,
    requestSubmissionPaymentFail,
    unPublishContestFail,
    unPublishContestSuccess,
    updateContestFail,
    updateContestSuccess,
    provisionContestCategoriesSuccess,
    provisionContestCategoriesFail,
    convertContestSubmissionModeSuccess,
    convertContestSubmissionModeFail,
    updateHostFail,
    updateHostSuccess,
    updatePartnerFail,
    updatePartnerSuccess,
    updatePartner as updatePartnerAction,
    updateHost as updateHostAction,
    deleteAwardCategorySuccess,
    deleteAwardCategoryFail,
    getContestSubmissionsSuccess,
    getContestSubmissionsFail,
    getContestManage,
    getContestManageSuccess,
    getContestManageFail,
    updateCampaignAwardsSuccess,
    updateCampaignAwardsFail,
    updateAwardCategorySuccess,
    updateAwardCategoryFail,
    verifyProjectSuccess,
    verifyProjectFail,
    // Video Management Actions
    getPreselectionSubmissionsFail,
    getPreselectionSubmissionsSuccess,
    preselectSubmissionsSuccess,
    preselectSubmissionsFail,
    sendSelectionEmailFail,
    sendSelectionEmailSuccess,
} from './actions';
import { globalErrorHandler } from '../error/saga';
import { api } from '../../configurations/api';
import {
    assignRedeemableCodeUrl,
    awardsCategoryUrl,
    awardsUrl,
    downloadContestAssetUrl,
    getContestMetricsUrl,
    getContestUrl,
    getContestWithContestIdUrl,
    getMySubmissionsUrl,
    getRecommendationUrl,
    getRedeemableCodesUrl,
    getSavedCollectionUrl,
    hostUrl,
    partnerUrl,
    publishContestUrl,
    saveCollectionUrl,
    scoreCategoryUrl,
    submissionsUrl,
    unPublishContesturl,
    winnersEmailUrl,
    contestSubmissionModeToRegularUrl,
    contestSubmissionModeToTierUrl,
} from '../../configurations/api/url';
import { httpRequest } from '../types';
import { resolveSubmissionCategoryId } from '../../utils/contestSubmissionCategory';
import { provisionContestCategoriesAndAwards } from './provisionContestAwards';
import {
    IContest,
    IGenericDocumentModifier,
    IGetAllResponse,
    IReedemableCode,
    ISubmission,
} from '../../types/global/helper';
import {
    ISubmitProject,
    ICompleteSubmissionPayment,
    IRequestSubmissionPayment,
    types,
    IGetContestPayload,
    IGetContests,
    IInitiate2FaForVote,
    ICastVote,
    ICreateBookmark,
    ICreateContestPayload,
    IFundContestFromWalletPayload,
    IConvertContestSubmissionModePayload,
    IGetUserContest,
    IGetUserContests,
    ICreateHost,
    IGetHost,
    IGetAllHosts,
    ICreatePartner,
    IGetPartner,
    IGetAllPartners,
    ISearchPayload,
    ISearchHostResponse,
    ISearchPartnerResponse,
    ICreateAwardCategory,
    IAssignRedeemableCode,
    IGetRedeemableCodes,
    IAwardPrize,
    ICreateWinnersEmail,
    IGetAllSubmissions,
    ICreateScoreCategory,
    IGetUnsubmittedProjects,
    IContestInitialState,
    ISendContestEmail,
    IGetS3ImagesPayload,
    IGetS3ImagesSuccessPayload,
    IS3ImagesPagination,
    IGetSubmissions,
    IBookmark,
    IGetSavedCollections,
    IGetContestSubmissions,
    IGetManageCampiagn,
    IUpdateCampaignAwards,
    IGetPreselectionSubmissions,
    ISendSelectionEmail,
    IPreselectSubmissions,
    IUpdateSubmission,
} from './types';
import { CACHE_TYPE, CacheValue, NotUniqueCacheValue } from '../cache/types';
import { getCacheByType, getCacheDuration, getNotUniqueCacheByKey, isUseCacheEnabled } from '../cache/saga';
import { destroyOneCache, setCache } from '../cache/action';
import { getUsersDashboard } from '../user/actions';
import { showToastMessage } from '../../utils/AppUtils';
import { IErrorType } from '../../constants/types';
import { setInAppNotification } from '../in-app-notification/actions';
import { SentryCapture } from '../../analytics/Sentry';
import { Action } from 'redux';
import { isEmpty } from '../../utils/lodash';
import { navigate } from '../navigator/action';
import { ROUTES } from '../../types/global/routes.types';
import { replaceRouteParam } from '../../utils/routesProcessor';
import { refreshUserDashboard } from '../account/actions';
import { getProject } from '../project/saga';
import { RootState } from '../root-reducer';

function* verifyProject({ payload, resolve, reject }: { payload: ISubmitProject; resolve: any; reject: any }): any {
    try {
        const response = yield call(api, `${submissionsUrl}/validate`, httpRequest.POST, payload);
        const { message, reason } = response;
        yield put(verifyProjectSuccess({ message, reason }));
        if (resolve) resolve({ message, reason });
    } catch (error: any) {
        yield put(verifyProjectFail(error));
        if (reject) reject(error);
    }
}

/** The below will aid the host in self submitting.
 * The idea is to have them upload their own projects
 * then submit it. This below will return only the projects that have not been submitted
 */
function* getUnsubmittedProjects({ payload }: { payload: IGetUnsubmittedProjects }): Generator<any, any, any> {
    const defaultUseCache = yield* isUseCacheEnabled();
    const { contestId, sortBy, limit, page, searchTerm } = payload;
    const params = new URLSearchParams();

    if (limit) {
        params.append('limit', limit.toString());
    }

    if (sortBy) {
        params.append('sort', sortBy);
    }

    if (page) {
        params.append('page', page.toString());
    }

    if (searchTerm) {
        params.append('searchTerm', searchTerm);
    }

    const queryString = params.toString();

    const appended = queryString ? `?${queryString}` : '';

    let initialResult: any = null;
    const localCacheKey = `${queryString}-${contestId}`;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.UNSUBMITTED_PROJECTS, localCacheKey);
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (defaultUseCache && initialResult) {
        yield put(
            getUsersUnsubmittedProjectsSuccess({
                ...initialResult,
                details: payload,
            }),
        );
    } else {
        try {
            const request = `${getContestUrl}/${contestId}/unsubmitted${appended}`;
            const response = yield call(api, request, httpRequest.GET, null, 2);
            const { data } = response;
            yield put(
                getUsersUnsubmittedProjectsSuccess({
                    ...data,
                    details: payload,
                }),
            );
            yield put(
                setCache({
                    key: localCacheKey,
                    value: data,
                    type: CACHE_TYPE.UNSUBMITTED_PROJECTS,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            yield put(getUsersUnsubmittedProjectsFail(error));
        }
    }
}

function* getContestReferences({ payload }: { payload: string[] }): any {
    try {
        const projectCalls = payload.map(id =>
            getProject({ payload: { id, skipAuthentication: true, withNavigate: false, skipMediaSet: true } }),
        );
        const projects = yield all(projectCalls);
        yield put(getContestReferencesSuccess(projects));
    } catch (error: any) {
        yield put(getContestReferencesFail(error));
    }
}

function* createScoreCategory({ payload }: { payload: ICreateScoreCategory }): Generator<any, any, any> {
    try {
        const response = yield call(api, scoreCategoryUrl, httpRequest.POST, payload);
        const { data } = response.data;
        yield put(createScoreCategorySuccess(data));
    } catch (error: any) {
        yield put(createScoreCategoryFail(error));
    }
}

function* getContestScoreBoard({ payload }: { payload: IGetAllSubmissions }): Generator<any, any, any> {
    const { contestId, sortBy, limit, page, refresh } = payload;
    let params = '';
    if (sortBy) {
        params += `?sortby=${sortBy}`;
    }
    if (limit) {
        params += `&limit=${limit}`;
    }

    if (page) {
        params += `&page=${page}`;
    }

    if (refresh) {
        const now = new Date().toISOString();
        params += `&refresh=${refresh}&date=${now}`;
    }
    const request = `${getContestUrl}/${contestId}/score${params}`;
    try {
        const response = yield call(api, request, httpRequest.GET, {}, 2, 1000);
        const { data } = response;
        yield put(
            getAllSubmissionSuccess({
                submissions: data,
                details: payload,
            }),
        );
    } catch (error: any) {
        yield put(getAllSubmissionFail(error));
    }
}

function* sendConclusionEmail({ payload }: { payload: ICreateWinnersEmail }): Generator<any, any, any> {
    try {
        yield call(api, winnersEmailUrl, httpRequest.POST, payload);
        yield put(sendWinnersEmailSucess());
        yield* updateContest({
            payload: {
                documentId: payload.contestId,
                payload: {
                    winner_email_sent: !payload.is_test,
                },
            },
        });
        yield delay(1000);
        /** Fetch the contest again to update the new values */
        yield* getUserContest({
            payload: {
                contestId: payload.contestId,
                skipRefresh: true,
                withNavigate: false,
            },
        });
    } catch (error: any) {
        yield put(sendWinnersEmailFail(error));
    }
}

function parseS3ImagesResponse(
    response: { data?: Record<string, unknown> },
    fallbackPage: number,
    fallbackLimit: number,
): { images: string[]; pagination: IS3ImagesPagination } {
    const root = (response.data?.data ?? response.data) as Record<string, unknown> | undefined;
    const imagesRaw = root?.images ?? root?.s3Images;
    const images = Array.isArray(imagesRaw) ? (imagesRaw as string[]) : [];
    const nested = (root?.pagination ?? {}) as Record<string, number>;
    const page = Number(nested.page ?? root?.page ?? fallbackPage) || fallbackPage;
    const limit = Number(nested.limit ?? root?.limit ?? fallbackLimit) || fallbackLimit;
    const total = Number(nested.total ?? root?.total ?? images.length) || 0;
    const total_pages =
        Number(nested.total_pages ?? root?.total_pages) || (limit > 0 ? Math.max(1, Math.ceil(total / limit)) : 1);
    return {
        images,
        pagination: { page, limit, total, total_pages },
    };
}

function* getS3ImagesSaga({ payload }: { payload?: IGetS3ImagesPayload }): Generator<any, any, any> {
    const page = Math.max(1, payload?.page ?? 1);
    const limit = Math.min(50, Math.max(1, payload?.limit ?? 10));
    const append = Boolean(payload?.append);
    try {
        const qs = new URLSearchParams({ page: String(page), limit: String(limit) });
        const response = yield call(api, `${getContestUrl}/s3-images?${qs}`, httpRequest.GET, null);
        const { images, pagination } = parseS3ImagesResponse(response, page, limit);
        const successPayload: IGetS3ImagesSuccessPayload = { images, pagination, append };
        yield put(getS3imagesSuccess(successPayload));
    } catch (error: any) {
        yield put(getS3imagesFail(error));
    }
}

function* sendContestEmailSaga({ payload }: { payload: ISendContestEmail }): Generator<any, any, any> {
    let apiUrl = '';
    let successMessage = '';
    if (payload.type && payload.type.length > 0) {
        const emailType = payload.type[0];
        try {
            if (emailType === 'contest submission notification email') {
                apiUrl = `${getContestUrl}/${payload.contestId}/submission-reminder-email`;
                successMessage = 'Contest submission notification email sent';
            } else if (emailType === 'voting reminder email') {
                apiUrl = `${getContestUrl}/vote-reminder`;
                successMessage = 'Voting reminder email sent';
            } else if (emailType === 'contest notification email') {
                apiUrl = `${getContestUrl}/${payload.contestId}/notify`;
                successMessage = 'Contest notification email sent';
            } else if (emailType === 'send contest open email') {
                apiUrl = `${getContestUrl}/${payload.contestId}/submission-open-email`;
                successMessage = 'Contest open email sent';
            }
            yield call(api, apiUrl, httpRequest.POST, {
                contestId: payload.contestId,
                subject: payload.subject,
                image: payload.image,
                message: payload.message,
                testUsers:
                    payload.testUsers && payload.testUsers.length > 0
                        ? payload.testUsers.map((u: any) => u._id || u)
                        : undefined,
                audienceScope: payload.audienceScope || 'participants',
                doNotRepeat: payload.doNotRepeat !== false,
                largeHeroImage: Boolean(payload.largeHeroImage),
            });

            yield put(sendContestEmailSucess());
            yield delay(1000);

            yield call(showToastMessage, successMessage, 'success');

            yield* getUserContest({
                payload: {
                    contestId: payload.contestId,
                    skipRefresh: true,
                    withNavigate: false,
                },
            });
        } catch (error: any) {
            yield put(sendContestEmailFail(error));
        }
    }
}

function* downloadAsset({ payload, resolve, reject }: any): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${downloadContestAssetUrl}`,
            httpRequest.POST,
            payload,
            0,
            1000,
            false,
            undefined,
            undefined,
            undefined,
            'blob',
        );
        yield put(downloadAssetSuccess(response));
        resolve(response);
    } catch (error: any) {
        SentryCapture(error, 'error');
        reject(error);
        yield put(downloadAssetFail(error));
    }
}
function* getAssignedCodes({ payload }: { payload: IGetRedeemableCodes }): Generator<any, any, any> {
    const defaultUseCache = yield* isUseCacheEnabled();
    const { contestId, limit = 100, page = 0 } = payload;
    let initialResult: any = null;
    const request = `${getRedeemableCodesUrl}?contest=${contestId}&page=${page}&limit=${limit}`;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.REDEEMABLE_CODE, contestId);
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (defaultUseCache && initialResult) {
        yield put(getRedeemableCodesSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, request, httpRequest.GET, null, 2, 1000);
            const { data } = response.data;
            yield put(getRedeemableCodesSuccess(data));
            yield put(
                setCache({
                    key: contestId,
                    value: data,
                    type: CACHE_TYPE.REDEEMABLE_CODE,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            yield put(getRedeemableCodesFail(error));
        }
    }
}

function* assignCodes({
    payload,
    resolve,
    reject,
}: {
    payload: IAssignRedeemableCode;
    resolve: any;
    reject: any;
}): Generator<any, any, any> {
    const { contestId, userId } = payload;
    /** Create code First
     *
     */
    try {
        const response = yield call(api, getRedeemableCodesUrl, httpRequest.POST, { contest: contestId }, 0, 1000);
        const { data }: { data: IReedemableCode } = response;
        if (data) {
            /** Send to user */
            const userResponse = yield call(api, assignRedeemableCodeUrl, httpRequest.POST, {
                userId,
                redeemCodeId: data._id,
            });
            const redeemcodeObject = userResponse;
            yield put(assignRedeemableCodeSuccess(redeemcodeObject.data));
            yield put(
                destroyOneCache({
                    cacheType: CACHE_TYPE.REDEEMABLE_CODE,
                }),
            );
        }
        yield call(showToastMessage, 'Code sent successfully', 'success');
        resolve(response);
    } catch (error: any) {
        yield call(globalErrorHandler, error);
        yield put(assignRedeemableCodeFail(error));
        reject(error);
    }
}

function* createAwardCategory({
    payload,
}: {
    payload: ICreateAwardCategory & {
        position?: string;
        tier_label?: string;
        tier_name?: string;
        tier_position?: string;
    };
}): any {
    try {
        const response = yield call(api, awardsCategoryUrl, httpRequest.POST, payload, 0, 0);
        const { data } = response.data;
        yield put(createAwardCategorySuccess(data));
        if (payload.category) {
            // Tiered awards use position + tier_label (tier_position is also set in manage UI)
            const isTieredPricing = !!(payload.tier_label && (payload.position || payload.tier_position));

            // Only update category_awards if it's NOT a tiered pricing award
            if (!isTieredPricing) {
                yield* updateCampaignAwardCategories({
                    payload: {
                        action: 'add',
                        awardCategoryId: data._id,
                        categoryId: payload.category,
                        contestId: payload.contest,
                    },
                });
            }

            // Handle prize_structure for tiered pricing
            if (isTieredPricing) {
                yield* updatePrizeStructureForAward({
                    contestId: payload.contest,
                    categoryId: payload.category,
                    awardId: data._id,
                    position: payload.position!,
                    action: 'add',
                });
            }
        }
        return data;
    } catch (error: any) {
        yield call(globalErrorHandler, error);
        SentryCapture(error, 'error');
        yield put(createAwardCategoryFail(error));
    }
}

function* updateAwardCategory({ payload }: { payload: IGenericDocumentModifier }): any {
    try {
        const response = yield call(
            api,
            `${awardsCategoryUrl}/${payload.documentId}`,
            httpRequest.PATCH,
            payload.payload,
            0,
            0,
        );
        const { data } = response.data;

        // Handle prize_structure for tiered pricing - check if position/tier changed
        const newPosition = (payload.payload as any).position;
        const newTierLabel = (payload.payload as any).tier_label;
        const { oldPosition } = payload.additionalPayload;
        const { oldTierLabel } = payload.additionalPayload;

        // Check if this is a tiered pricing award
        const isTieredPricing = !!(newPosition || oldPosition);

        // Only update category_awards if it's NOT a tiered pricing award
        if (payload.payload.category && !isTieredPricing) {
            yield* updateCampaignAwardCategories({
                payload: {
                    action: 'add',
                    awardCategoryId: data._id,
                    categoryId: payload.payload.category,
                    contestId: data.contest,
                },
            });
        }

        // Handle prize_structure for tiered pricing
        if (isTieredPricing && data.contest && payload.payload.category) {
            // If position or tier changed, update prize_structure
            if (oldPosition !== newPosition || oldTierLabel !== newTierLabel) {
                // Remove from old position if it existed
                if (oldPosition) {
                    yield* updatePrizeStructureForAward({
                        contestId: data.contest,
                        categoryId: payload.payload.category,
                        awardId: data._id,
                        position: oldPosition,
                        action: 'remove',
                    });
                }
                // Add to new position (if new position exists)
                if (newPosition) {
                    yield* updatePrizeStructureForAward({
                        contestId: data.contest,
                        categoryId: payload.payload.category,
                        awardId: data._id,
                        position: newPosition,
                        action: 'add',
                    });
                }
            } else if (!oldPosition && newPosition) {
                // New position assignment
                yield* updatePrizeStructureForAward({
                    contestId: data.contest,
                    categoryId: payload.payload.category,
                    awardId: data._id,
                    position: newPosition,
                    action: 'add',
                });
            }
        }
        yield put(updateAwardCategorySuccess({ body: data, payload: payload.payload }));
        yield call(showToastMessage, 'Prize updated successfully.', 'success');
        return data;
    } catch (error: any) {
        yield call(globalErrorHandler, error);
        SentryCapture(error, 'error');
        yield put(updateAwardCategoryFail(error));
    }
}

function* deleteAwardCategory({
    payload,
}: {
    payload: IGenericDocumentModifier & { position?: string };
}): Generator<any, any, any> {
    try {
        const awardId = payload.documentId;
        const position = payload.position || (payload.payload as any)?.position;

        yield call(api, `${awardsCategoryUrl}/${awardId}`, httpRequest.DELETE, payload, 0, 0);
        yield put(deleteAwardCategorySuccess(payload));
        yield call(showToastMessage, 'Prize removed successfully.', 'success');

        if (payload?.payload?.categoryId && payload?.payload?.contestId) {
            yield* updateCampaignAwardCategories({
                payload: {
                    action: 'remove',
                    awardCategoryId: awardId,
                    categoryId: payload.payload.categoryId,
                    contestId: payload.payload.contestId,
                },
            });

            // Handle prize_structure for tiered pricing - remove from prize_structure
            if (position) {
                yield* updatePrizeStructureForAward({
                    contestId: payload.payload.contestId,
                    categoryId: payload.payload.categoryId,
                    awardId: awardId,
                    position: position,
                    action: 'remove',
                });
            }
        }
    } catch (error: any) {
        yield call(globalErrorHandler, error);
        SentryCapture(error, 'error');
        yield put(deleteAwardCategoryFail(error));
    }
}

function* getAwardCategories({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${awardsCategoryUrl}?contest=${payload.documentId}`,
            httpRequest.GET,
            {},
            0,
            0,
        );
        const { data } = response.data;
        yield put(getAwardCategoriesForContestSuccess(data));
    } catch (error: any) {
        yield put(getAwardCategoriesForContestFail(error));
    }
}

function* getAwardPrizes({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(api, `${awardsUrl}?contest=${payload.documentId}`, httpRequest.GET, {}, 0, 0);
        const { data } = response.data;
        yield put(getContestAwardsSuccess(data));
    } catch (error: any) {
        yield put(getContestAwardsFail(error));
    }
}

function* awardOnePrize(award: IAwardPrize): Generator<any, any, any> {
    try {
        const response = yield call(api, `${awardsUrl}`, httpRequest.POST, award, 0, 0);
        yield delay(1000);
        const { data } = response;
        yield put(awardPrizeSuccess(data));
        yield call(showToastMessage, 'Prize awarded successfully', 'success');
    } catch (error: any) {
        yield put(awardPrizeFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* awardMultiplePrizez({ payload }: { payload: IAwardPrize[] }): Generator<any, any, any> {
    try {
        yield all(payload.map(award => awardOnePrize(award)));
    } catch (error: any) {
        yield put(awardPrizeFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* searchHost({ payload }: { payload: ISearchPayload }): any {
    const defaultUseCache = yield* isUseCacheEnabled();
    const { searchTerm } = payload;
    let initialResult: any = null;

    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.HOST_SEARCH, searchTerm);
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(searchHostSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${hostUrl}/search`, httpRequest.POST, payload, 2);
            const { data }: { data: ISearchHostResponse } = response;
            yield put(searchHostSuccess(data.result));
            yield put(
                setCache({
                    key: searchTerm,
                    value: data.result,
                    type: CACHE_TYPE.HOST_SEARCH,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(searchHostFail(error));
        }
    }
}

function* searchPartner({ payload }: { payload: ISearchPayload }): any {
    const defaultUseCache = yield* isUseCacheEnabled();
    const { searchTerm } = payload;
    let initialResult: any = null;

    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.PARTNER_SEARCH, searchTerm);
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(searchPartnerSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${partnerUrl}/search`, httpRequest.POST, payload, 2);
            const { data }: { data: ISearchPartnerResponse } = response;
            yield put(searchPartnerSuccess(data.result));
            yield put(
                setCache({
                    key: searchTerm,
                    value: data.result,
                    type: CACHE_TYPE.PARTNER_SEARCH,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(searchPartnerFail(error));
        }
    }
}

type Phase = {
    date_started: string;
    expiration_date: string;
    phase: string;
    timezone: string;
};

function getDateRange(phases: Phase[]): { earliestStart: Date; latestEnd: Date } {
    // Sort by date_started
    const sorted = [...phases].sort((a, b) => new Date(a.date_started).getTime() - new Date(b.date_started).getTime());

    const earliestStart = new Date(sorted[0].date_started);

    const latestEnd = new Date(
        phases.reduce((latest, curr) =>
            new Date(curr.expiration_date) > new Date(latest.expiration_date) ? curr : latest,
        ).expiration_date,
    );

    return { earliestStart, latestEnd };
}

interface IPrasedCntestPayload {
    feature_image?: any;
    categories?: any;
    mobile_feature_image?: any;
    contest_media?: any;
    body: Record<string, any>;
}
const parseCampaignPayload = (payload: ICreateContestPayload): IPrasedCntestPayload => {
    const final: IPrasedCntestPayload = {
        feature_image: [],
        categories: [],
        mobile_feature_image: null,
        contest_media: null,
        body: {},
    };

    Object.keys(payload).forEach(key => {
        const currentKey = key as keyof ICreateContestPayload;
        switch (key) {
            case 'feature_image':
                final.feature_image = payload[currentKey];
                break;
            case 'mobile_feature_image':
                final.mobile_feature_image = payload[currentKey];
                break;
            case 'categories':
                final.categories = payload[currentKey];
                break;
            case 'contest_media':
                final.contest_media = payload[currentKey];
                break;
            default:
                if (
                    !['submission_state_message', 'mobile_feature_image_preview', 'feature_image_preview'].includes(key)
                ) {
                    if (key === 'contest_phase_dates' && payload[currentKey] && !isEmpty(payload[currentKey])) {
                        const { earliestStart, latestEnd } = getDateRange(payload[currentKey] as Phase[]);
                        final.body['date_start'] = earliestStart;
                        final.body['expiration_date'] = latestEnd;
                    }
                    final.body[currentKey] = payload[currentKey];
                }
                break;
        }
    });

    return final;
};

function* createContest({
    payload,
    resolve,
    reject,
}: {
    payload: ICreateContestPayload;
    resolve?: (data: unknown) => void;
    reject?: (error: unknown) => void;
}): Generator<any, any, any> {
    const { body, categories, contest_media, feature_image, mobile_feature_image } = parseCampaignPayload(payload);

    let featureImageUpload: any[] | undefined;
    let mobileFeatureImageUpload: any[] | undefined;
    let contestMediaUploads: any[] | undefined;
    let contestAttachmentUpload: any[] | undefined;

    try {
        // Create the contest first
        const response = yield call(api, getContestUrl, httpRequest.POST, body, 0, 1000);
        const { data } = response.data;

        /** Upload Media (if present) */
        if (feature_image) {
            featureImageUpload = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'contest',
                    directory: 'media',
                    path: 'images',
                    files: feature_image,
                    id: data._id,
                },
            });
        }

        if (mobile_feature_image) {
            mobileFeatureImageUpload = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'contest',
                    directory: 'media',
                    path: 'images',
                    files: mobile_feature_image,
                    id: data._id,
                },
            });
        }

        // Handle contest_media (PDF/ZIP attachments) if present
        if (contest_media && Array.isArray(contest_media) && contest_media.length > 0) {
            const mediaFiles = contest_media.filter((item: any) => item instanceof File);

            if (mediaFiles.length > 0) {
                // Check if files are PDF/ZIP (attachments) or other media (assets)
                const attachmentFiles = mediaFiles.filter((file: File) => {
                    const name = file.name.toLowerCase();
                    return name.endsWith('.pdf') || name.endsWith('.zip');
                });
                const assetFiles = mediaFiles.filter((file: File) => {
                    const name = file.name.toLowerCase();
                    return !name.endsWith('.pdf') && !name.endsWith('.zip');
                });

                if (assetFiles.length > 0) {
                    contestMediaUploads = yield call(uploadFilesSaga as any, {
                        payload: {
                            collection: 'contest',
                            directory: 'media',
                            path: 'assets',
                            files: assetFiles,
                            id: data._id,
                        },
                    });
                }

                if (attachmentFiles.length > 0) {
                    contestAttachmentUpload = yield call(uploadFilesSaga as any, {
                        payload: {
                            collection: 'contest',
                            directory: 'media',
                            path: 'attachments',
                            files: attachmentFiles,
                            id: data._id,
                        },
                    });
                }
            }
        }

        // Build update body
        const updateBody: any = {};

        if (featureImageUpload?.length) {
            updateBody.feature_image = featureImageUpload[0];
        }

        if (mobileFeatureImageUpload?.length) {
            updateBody.mobile_feature_image = mobileFeatureImageUpload[0];
        }

        // Handle contest_media - merge URLs and uploaded file keys
        if (contest_media && Array.isArray(contest_media)) {
            const existingUrls = contest_media.filter((item: any) => typeof item === 'string');
            const allMediaUrls = [...existingUrls];
            if (contestMediaUploads) allMediaUrls.push(...contestMediaUploads);
            if (contestAttachmentUpload) allMediaUrls.push(...contestAttachmentUpload);
            if (allMediaUrls.length > 0) {
                updateBody.contest_media = allMediaUrls;
            }
        } else if (contestMediaUploads?.length || contestAttachmentUpload?.length) {
            const allMediaUrls: string[] = [];
            if (contestMediaUploads) allMediaUrls.push(...contestMediaUploads);
            if (contestAttachmentUpload) allMediaUrls.push(...contestAttachmentUpload);
            if (allMediaUrls.length > 0) {
                updateBody.contest_media = allMediaUrls;
            }
        }

        let finalContest: any = data;

        if (Array.isArray(categories) && categories.length > 0) {
            finalContest = yield* provisionContestCategoriesAndAwards(data._id, categories);
        }

        const mediaUpdate = { ...updateBody };
        delete mediaUpdate.categories;

        if (Object.keys(mediaUpdate).length > 0) {
            const mediaRes = yield call(
                api,
                `${getContestUrl}/${data._id}`,
                httpRequest.PATCH,
                mediaUpdate,
                0,
                0,
                false,
            );
            const mediaData = mediaRes.data?.data ?? mediaRes.data;
            finalContest = { ...finalContest, ...mediaData };
        }

        yield put(createContestSuccess(finalContest));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.DISCOVERY }));
        if (resolve) resolve(finalContest);
        // yield call(showToastMessage, 'Contest created successfully.', 'success');
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(createContestFail(error));
        if (reject) reject(error);
    }
}

function* publishContest({
    payload,
    resolve,
    reject,
}: {
    payload: IGenericDocumentModifier;
    resolve?: (data: unknown) => void;
    reject?: (error: unknown) => void;
}): Generator<any, any, any> {
    try {
        const response = yield call(api, `${publishContestUrl}/${payload.documentId}`, httpRequest.PATCH, {}, 2, 1000);
        const data = response?.data?.data ?? response?.data ?? response;
        yield put(publishContestSuccess(data));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
        yield call(showToastMessage, 'Contest published successfully.', 'success');
        if (resolve) resolve(data);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(publishContestFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* getContestFundingRequirementsSaga({
    payload: contestId,
    resolve,
    reject,
}: {
    payload: string;
    resolve?: (data: unknown) => void;
    reject?: (error: unknown) => void;
}): Generator<any, any, any> {
    try {
        const response = yield call(api, `${getContestUrl}/${contestId}/funding-requirements`, httpRequest.GET, null);
        const data = response.data?.data ?? response.data;
        if (resolve) resolve(data);
    } catch (error: any) {
        SentryCapture(error, 'error');
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* fundContestFromWalletSaga({
    payload,
    resolve,
    reject,
}: {
    payload: IFundContestFromWalletPayload;
    resolve?: (data: unknown) => void;
    reject?: (error: unknown) => void;
}): Generator<any, any, any> {
    try {
        const body =
            payload.amount_cents != null && payload.amount_cents > 0 ? { amount_cents: payload.amount_cents } : {};
        const response = yield call(
            api,
            `${getContestUrl}/${payload.contestId}/fund-from-wallet`,
            httpRequest.POST,
            body,
        );
        const data = response.data?.data ?? response.data;
        const requirements = data?.requirements ?? data;
        yield call(showToastMessage, data?.message || 'Prize pool funded from your campaign wallet', 'success');
        if (resolve) resolve({ ...data, requirements });
    } catch (error: any) {
        SentryCapture(error, 'error');
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* convertContestSubmissionModeSaga({
    payload,
    resolve,
    reject,
}: {
    payload: IConvertContestSubmissionModePayload;
    resolve?: (data: unknown) => void;
    reject?: (error: unknown) => void;
}): Generator<any, any, any> {
    try {
        const url =
            payload.direction === 'to-regular'
                ? contestSubmissionModeToRegularUrl(payload.contestId)
                : contestSubmissionModeToTierUrl(payload.contestId);
        const response = yield call(api, url, httpRequest.POST, payload.body, 0, 0, false);
        const data = response.data?.data ?? response.data;
        yield put(convertContestSubmissionModeSuccess(data));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.DISCOVERY }));
        yield put(getContestManage({ contestId: payload.contestId }));
        const modeLabel = payload.direction === 'to-regular' ? 'flat fee (regular)' : 'tiered pricing';
        yield call(showToastMessage, `Submission mode updated to ${modeLabel}.`, 'success');
        if (resolve) resolve(data);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(convertContestSubmissionModeFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* unPublishContest({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${unPublishContesturl}/${payload.documentId}`,
            httpRequest.PATCH,
            {},
            2,
            1000,
        );
        const { data } = response;
        yield put(unPublishContestSuccess(data));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
        yield call(showToastMessage, 'Contest Updated successfully.', 'success');
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(unPublishContestFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* updateCampaignAwardCategories({ payload }: { payload: IUpdateCampaignAwards }): Generator<any, any, any> {
    try {
        const response = yield call(api, `${getContestUrl}/update-award`, httpRequest.POST, payload, 0, 0, false);
        const { data, message } = response;
        yield put(updateCampaignAwardsSuccess(data));
        yield call(showToastMessage, message, 'success');
    } catch (error: any) {
        SentryCapture(error);
        yield put(updateCampaignAwardsFail(error));
        yield call(globalErrorHandler, error);
    }
}

// Helper function to update prize_structure for tiered pricing
function* updatePrizeStructureForAward({
    contestId,
    categoryId,
    awardId,
    position,
    action,
}: {
    contestId: string;
    categoryId: string;
    awardId: string;
    position: string;
    action: 'add' | 'remove';
}): Generator<any, any, any> {
    try {
        // Get current contest data from state
        const state: any = yield select();
        const managedContest = state.contest?.managedContest;
        const contest = managedContest?.contest;

        if (!contest) {
            console.warn('Contest not found in state for prize_structure update');
            return;
        }

        return yield* updatePrizeStructureInContest(contest, categoryId, awardId, position, action, contestId);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
    }
}

function* updatePrizeStructureInContest(
    contest: any,
    categoryId: string,
    awardId: string,
    position: string,
    action: 'add' | 'remove',
    contestId: string,
): Generator<any, any, any> {
    try {
        if (!contest.categories || !Array.isArray(contest.categories)) return;

        const categoryIndex = contest.categories.findIndex((cat: any) => cat._id === categoryId);
        if (categoryIndex === -1) return;

        const category = contest.categories[categoryIndex];
        if (!category.with_tiered_pricing || !category.prize_structure) return;

        // Clone the categories array
        const updatedCategories = [...contest.categories];
        const updatedCategory = { ...updatedCategories[categoryIndex] };
        const prizeStructure = [...(updatedCategory.prize_structure || [])];

        // Find or create the position in prize_structure
        let positionIndex = prizeStructure.findIndex((prize: any) => prize.position === position);

        if (positionIndex === -1 && action === 'add') {
            // Create new position if it doesn't exist
            prizeStructure.push({
                position: position,
                payouts: [awardId],
            });
        } else if (positionIndex !== -1) {
            // Update existing position
            const payouts = [...(prizeStructure[positionIndex].payouts || [])];

            if (action === 'add') {
                // Add award if not already present
                if (!payouts.includes(awardId)) {
                    payouts.push(awardId);
                }
            } else if (action === 'remove') {
                // Remove award
                const awardIndex = payouts.indexOf(awardId);
                if (awardIndex !== -1) {
                    payouts.splice(awardIndex, 1);
                }
            }

            prizeStructure[positionIndex] = {
                ...prizeStructure[positionIndex],
                payouts: payouts,
            };
        }

        updatedCategory.prize_structure = prizeStructure;
        updatedCategories[categoryIndex] = updatedCategory;

        // Update the contest
        yield* updateContest({
            payload: {
                documentId: contestId,
                payload: {
                    categories: updatedCategories,
                },
            },
        });
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
    }
}

function* provisionContestCategories({
    payload,
    resolve,
    reject,
}: {
    payload: { contestId: string; categories: Record<string, unknown>[]; categoriesEnabled?: boolean };
    resolve?: (data: unknown) => void;
    reject?: (error: unknown) => void;
}): Generator<any, any, any> {
    try {
        let finalContest = yield* provisionContestCategoriesAndAwards(payload.contestId, payload.categories);

        if (payload.categoriesEnabled) {
            const patchRes = yield call(
                api,
                `${getContestUrl}/${payload.contestId}`,
                httpRequest.PATCH,
                { categories_enabled: true },
                0,
                0,
                false,
            );
            const patchData = patchRes.data?.data ?? patchRes.data;
            finalContest = { ...finalContest, ...patchData };
        }

        const contestPayload = finalContest as unknown as IContest;
        yield put(provisionContestCategoriesSuccess(contestPayload));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.DISCOVERY }));
        yield put(getContestManage({ contestId: payload.contestId }));
        yield call(showToastMessage, 'Submission categories saved.', 'success');
        if (resolve) resolve(finalContest);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(provisionContestCategoriesFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* updateContest({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    if (payload.fromCreate) {
        try {
            yield call(api, `${getContestUrl}/${payload.documentId}`, httpRequest.PATCH, payload.payload, 0, 0, false);
            yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
            yield put(destroyOneCache({ cacheType: CACHE_TYPE.DISCOVERY }));
            yield call(showToastMessage, 'Campaign Requested successfully.', 'success');
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield call(globalErrorHandler, error);
            yield put(updateContestFail(error));
        }
    } else {
        const { body, categories, contest_media, feature_image, mobile_feature_image } = parseCampaignPayload(
            payload.payload,
        );
        let featureImageUpload;
        let mobileFeatureImageUpload;
        let contestMediaUplaods;
        let contestAttachmentUpload;
        const updateBody: any = body;

        try {
            /** Updaate the Media */
            if (feature_image) {
                featureImageUpload = yield call(uploadFilesSaga as any, {
                    payload: {
                        collection: 'contest',
                        directory: 'media',
                        path: 'images',
                        files: feature_image,
                        id: payload.documentId,
                    },
                });
            }

            if (mobile_feature_image) {
                mobileFeatureImageUpload = yield call(uploadFilesSaga as any, {
                    payload: {
                        collection: 'contest',
                        directory: 'media',
                        path: 'images',
                        files: mobile_feature_image,
                        id: payload.documentId,
                    },
                });
            }

            // Handle contest_media - separate files from URLs
            if (contest_media && Array.isArray(contest_media)) {
                const mediaFiles = contest_media.filter((item: any) => item instanceof File);
                const mediaUrls = contest_media.filter((item: any) => typeof item === 'string');

                if (mediaFiles.length > 0) {
                    // Check if files are PDF/ZIP (attachments) or other media (assets)
                    const attachmentFiles = mediaFiles.filter((file: File) => {
                        const name = file.name.toLowerCase();
                        return name.endsWith('.pdf') || name.endsWith('.zip');
                    });
                    const assetFiles = mediaFiles.filter((file: File) => {
                        const name = file.name.toLowerCase();
                        return !name.endsWith('.pdf') && !name.endsWith('.zip');
                    });

                    if (assetFiles.length > 0) {
                        contestMediaUplaods = yield call(uploadFilesSaga as any, {
                            payload: {
                                collection: 'contest',
                                directory: 'media',
                                path: 'assets',
                                files: assetFiles,
                                id: payload.documentId,
                            },
                        });
                    }

                    if (attachmentFiles.length > 0) {
                        contestAttachmentUpload = yield call(uploadFilesSaga as any, {
                            payload: {
                                collection: 'contest',
                                directory: 'media',
                                path: 'attachments',
                                files: attachmentFiles,
                                id: payload.documentId,
                            },
                        });
                    }
                }

                const allUrls = [...mediaUrls];
                if (contestMediaUplaods) allUrls.push(...contestMediaUplaods);
                if (contestAttachmentUpload) allUrls.push(...contestAttachmentUpload);
                updateBody.contest_media = allUrls;
            }

            /** Check and fix */
            if (categories && !isEmpty(categories)) {
                const { category_awards } = categories;
                if (category_awards && !isEmpty(category_awards)) {
                    const awardCategories = yield all(
                        category_awards.map((p: any) => !p._id && call(createAwardCategory({ payload: { ...p } }))),
                    );
                    if (awardCategories) {
                        const internalCategory = categories.map((cat: any) => {
                            cat.category_awards = awardCategories;
                            return cat;
                        });
                        updateBody.categories = internalCategory;
                    }
                } else {
                    updateBody.categories = categories;
                }
            }

            if (featureImageUpload) {
                updateBody.feature_image = featureImageUpload[0];
            }

            if (mobileFeatureImageUpload) {
                updateBody.mobile_feature_image = mobileFeatureImageUpload[0];
            }

            // Note: contest_media handling is done above in the file upload section

            const response = yield call(
                api,
                `${getContestUrl}/${payload.documentId}`,
                httpRequest.PATCH,
                updateBody,
                0,
                0,
                false,
            );
            const { data } = response.data;
            yield put(updateContestSuccess(data));
            yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
            yield put(destroyOneCache({ cacheType: CACHE_TYPE.DISCOVERY }));
            yield call(showToastMessage, 'Campaign Updated successfully.', 'success');
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield call(globalErrorHandler, error);
            yield put(updateContestFail(error));
        }
    }
}

function* getUserContest({ payload }: { payload: IGetUserContest }): Generator<any, any, any> {
    let query = '?';
    if (payload.filter) query += `filter_by=${payload.filter}&`;
    if (payload.start) query += `start_date=${payload.start}&`;
    if (payload.end) query += `end_date=${payload.end}`;
    const key = `${payload.contestId}${query}`;
    const defaultUseCache = yield* isUseCacheEnabled();
    let initialResult: any = null;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.USER_CONTESTS, key);
    const route = replaceRouteParam(ROUTES.ESCONTEST_ENGAGE, 'contestId', payload.contestId);

    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(getUserContestSuccess(initialResult));
        if (payload.withNavigate) {
            yield put(
                navigate({
                    routes: route,
                }),
            );
        }
    } else {
        try {
            const response = yield call(api, `${getContestMetricsUrl}${key}`, httpRequest.GET, null, 0, 0);
            const { data } = response;
            yield put(getUserContestSuccess(data));
            if (payload.withNavigate) {
                yield put(
                    navigate({
                        routes: route,
                    }),
                );
            }
            yield put(
                setCache({
                    key,
                    type: CACHE_TYPE.USER_CONTESTS,
                    value: data,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getUserContestFail(error));
        }
    }
}

function* getUserContests({
    payload,
    resolve,
    reject,
}: {
    payload: IGetUserContests;
    resolve: (data: IGetUserContests) => void;
    reject: (error: any) => void;
}): Generator<any, any, any> {
    const queryParams = new URLSearchParams();
    if (payload.limit) queryParams.append('limit', String(payload.limit));
    if (payload.page) queryParams.append('page', String(payload.page));
    if (payload.scope === 'all') queryParams.append('scope', 'all');
    const search = (payload.search || payload.searchTerm || '').trim();
    if (search) queryParams.append('search', search);
    const cacheKey = `user-contest:${payload.scope === 'all' ? 'all' : 'mine'}:${search || '_'}:${payload.page || 1}:${
        payload.limit || 50
    }`;
    const defaultUseCache = yield* isUseCacheEnabled();
    /** Skip cache when searching so results stay fresh */
    const useCache = defaultUseCache && !search;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.USER_CONTESTS, cacheKey);
    let initialResult: any = null;
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && useCache) {
        yield put(getUserContestsSuccess(initialResult));
        if (resolve) {
            resolve(initialResult);
        }
    } else {
        try {
            const qs = queryParams.toString();
            const response = yield call(
                api,
                `${getContestUrl}/user-contest?${qs}${qs ? '&' : ''}sort=-createdAt`,
                httpRequest.GET,
                null,
                2,
                1000,
                false,
            );
            const { data } = response.data;
            yield put(getUserContestsSuccess(data));
            if (useCache) {
                yield put(
                    setCache({
                        key: cacheKey,
                        type: CACHE_TYPE.USER_CONTESTS,
                        value: data,
                        isUnique: false,
                    }),
                );
            }
            if (resolve) {
                resolve(data);
            }
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getUserContestsFail(error));
            if (reject) {
                reject(error);
            }
        }
    }
}

function* deleteContest({
    payload,
    resolve,
    reject,
}: {
    payload: IGenericDocumentModifier;
    resolve?: (data: unknown) => void;
    reject?: (error: unknown) => void;
}): Generator<any, any, any> {
    try {
        yield call(api, `${getContestUrl}/${payload.documentId}`, httpRequest.DELETE, null, 0, 1000);
        yield put(deleteContestSuccess(payload));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_CONTESTS }));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.DISCOVERY }));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USERS_DASHBOARD }));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.JURY_CAMPAIGNS }));
        yield put(
            getUsersDashboard({
                page: 1,
                limit: 40,
                category: 'campaigns',
                replaceData: true,
                skipRefresh: true,
            }),
        );
        yield call(showToastMessage, 'Contest deleted successfully', 'success');
        if (resolve) resolve(payload);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(deleteContestFail(error));
        if (reject) reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* createHost({ payload }: { payload: ICreateHost }): Generator<any, any, any> {
    try {
        const { profile_picture, ...restPayload } = payload;
        const response = yield call(api, hostUrl, httpRequest.POST, restPayload, 0, 0);
        const { data } = response.data;
        yield put(createHostSuccess(data));

        if (profile_picture) {
            const profilePicture = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'host',
                    directory: 'media',
                    path: 'image',
                    files: [profile_picture],
                    id: data._id,
                },
            });
            yield put(updateHostAction({ documentId: data._id, payload: { profile_picture: profilePicture[0] } }));
        }
        yield call(showToastMessage, 'Host created successfully!', 'success');
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.HOST,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(createHostFail(error));
    }
}

function* updateHost({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${hostUrl}/${payload.documentId}`,
            httpRequest.PATCH,
            payload.payload,
            0,
            0,
            false,
        );
        const { data } = response.data;
        yield put(updateHostSuccess(data));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.HOST,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(updateHostFail(error));
    }
}

function* deleteHost({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        yield call(api, `${hostUrl}/${payload.documentId}`, httpRequest.DELETE, null, 0, 0);
        yield put(deleteHostSuccess(payload));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.HOST,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(deleteHostFail(error));
    }
}

function* getHost({ payload }: { payload: IGetHost }): Generator<any, any, any> {
    let initialResult: any = null;
    const defaultUseCache = yield* isUseCacheEnabled();
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.HOST, payload.hostId);

    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(getHostSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${hostUrl}/${payload.hostId}`, httpRequest.GET, null, 0, 0);
            const { data } = response.data;
            yield put(getHostSuccess(data));
            yield put(
                setCache({
                    key: payload.hostId,
                    type: CACHE_TYPE.HOST,
                    value: data,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getHostFail(error));
        }
    }
}

function* getAllHost({ payload }: { payload: IGetAllHosts }): Generator<any, any, any> {
    let query = '?';
    if (payload.params) query += payload.params;

    const key = payload.params ?? 'all';
    const defaultUseCache = yield* isUseCacheEnabled();
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.HOST, key);

    let initialResult: any = null;
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (defaultUseCache && initialResult) {
        yield put(getHostSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${hostUrl}${query}`, httpRequest.GET, null, 0, 0);
            const { data } = response.data;
            yield put(getHostSuccess(data));
            yield put(
                setCache({
                    key: payload.params ?? 'all',
                    type: CACHE_TYPE.HOST,
                    value: data,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getHostFail(error));
        }
    }
}

function* createPartner({ payload }: { payload: ICreatePartner }): Generator<any, any, any> {
    try {
        const { profile_picture, ...restPayload } = payload;
        const response = yield call(api, partnerUrl, httpRequest.POST, restPayload, 0, 0);
        const { data } = response.data;
        yield put(createPartnerSuccess(data));
        if (profile_picture) {
            const profilePicture = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'partner',
                    directory: 'media',
                    path: 'image',
                    files: [profile_picture],
                    id: data._id,
                },
            });
            yield put(updatePartnerAction({ documentId: data._id, payload: { profile_picture: profilePicture[0] } }));
        }
        yield call(showToastMessage, 'Partner created successfully!', 'success');

        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.PARTNER,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(createPartnerFail(error));
    }
}

function* updatePartner({ payload }: { payload: IGenericDocumentModifier }): Generator<any, any, any> {
    try {
        const response = yield call(
            api,
            `${partnerUrl}/${payload.documentId}`,
            httpRequest.PATCH,
            payload.payload,
            0,
            0,
            false,
        );
        const { data } = response.data;
        yield put(updatePartnerSuccess(data));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.PARTNER,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(updatePartnerFail(error));
    }
}

function* delePartner({ payload }: { payload: IGenericDocumentModifier }) {
    try {
        yield call(api, `${partnerUrl}/${payload.documentId}`, httpRequest.DELETE, null, 0, 0);
        yield put(deletePartnerSuccess(payload));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.PARTNER,
            }),
        );
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(deletePartnerFail(error));
    }
}

function* getPartner({ payload }: { payload: IGetPartner }): Generator<any, any, any> {
    let initialResult: any = null;
    const defaultUseCache = yield* isUseCacheEnabled();
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.PARTNER, payload.partnerId);

    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (defaultUseCache && initialResult) {
        yield put(getPartnerSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${partnerUrl}/${payload.partnerId}`, httpRequest.GET, null, 0, 0);
            const { data } = response.data;
            yield put(getPartnerSuccess(data));
            yield put(
                setCache({
                    key: payload.partnerId,
                    type: CACHE_TYPE.HOST,
                    value: data,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getPartnerFail(error));
        }
    }
}

function* getAllPartners({ payload }: { payload: IGetAllPartners }): Generator<any, any, any> {
    let query = '?';
    if (payload.params) query += payload.params;

    const key = payload.params ?? 'all';
    const defaultUseCache = yield* isUseCacheEnabled();
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.PARTNER, key);

    let initialResult: any = null;
    if (cache && cache.key) {
        initialResult = cache.value;
    }

    if (initialResult && defaultUseCache) {
        yield put(getAllPartnersSuccess(initialResult));
    } else {
        try {
            const response = yield call(api, `${partnerUrl}${query}`, httpRequest.GET, null, 0, 0);
            const { data } = response.data;
            yield put(getAllPartnersSuccess(data));
            yield put(
                setCache({
                    key,
                    type: CACHE_TYPE.PARTNER,
                    value: data,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getAllPartnersFail(error));
        }
    }
}

/**TODO: Move all vote related saga away from here to the voting saga */
function* initiateVote({ payload, resolve, reject }: { payload: IInitiate2FaForVote; resolve: any; reject: any }): any {
    const url = `${submissionsUrl}/${payload.submission_id}/vote`;
    try {
        const response = yield call(api, url, httpRequest.POST, { phone_number: payload.phone_number }, 0, 0);
        const { data, message } = response || {};
        const { message: succesMessage } = data;
        if (succesMessage) {
            /** Here the user received the messag to verifyt their phone */
            yield put(initaiet2FAForVoteSuccess(data));
            yield put(
                setInAppNotification({
                    message: succesMessage,
                    title: succesMessage,
                }),
            );
            resolve(succesMessage);
            yield all([
                put(
                    setVotingFlow({
                        submissions: [],
                        showVotingModal: false,
                    }),
                ),
                put(setVoting2Fa(false)),
            ]);
        } else {
            /** Here they ae already verified and the vote goes through successfully */
            yield put(
                setInAppNotification({
                    message: message,
                    title: message,
                }),
            );
            yield put(castVoteSuccess(response.data.data));
            yield put(
                destroyOneCache({
                    cacheType: CACHE_TYPE.USER_VOTES,
                }),
            );
            yield all([
                put(
                    setVotingFlow({
                        submissions: [],
                        showVotingModal: false,
                    }),
                ),
                put(setVoting2Fa(false)),
            ]);
            resolve(response.data.data);
        }
    } catch (error: any) {
        SentryCapture(error, 'error');
        // Check for other error codes here as well
        if (error && error.data && error.data.message) {
            const payload: IErrorType = {
                data: {
                    message: error.data.message,
                    status: 'failed',
                },
                status: 403,
                statusText: error.data.message,
            };
            yield put(
                setInAppNotification({
                    message: error.data.message,
                    title: error.data.message,
                }),
            );
            yield put(initaiet2FAForVoteFail(payload));
        }
        yield all([
            put(
                setVotingFlow({
                    submissions: [],
                    showVotingModal: false,
                }),
            ),
            put(setVoting2Fa(false)),
        ]);
        reject(error);
    }
}

function* castVote({
    payload,
    resolve,
    reject,
}: {
    payload: ICastVote;
    resolve: () => Promise<void>;
    reject: () => Promise<void>;
}): any {
    const url = `${submissionsUrl}/${payload.submission_id}/vote/verify`;
    try {
        const response = yield call(api, url, httpRequest.POST, { ...payload }, 0, 0);
        const { data } = response;
        const { message } = data;
        yield put(castVoteSuccess(data));
        yield put(
            setInAppNotification({
                message: message,
                title: message,
            }),
        );
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.USER_VOTES,
            }),
        );

        yield all([
            put(
                setVotingFlow({
                    submissions: [],
                    showVotingModal: false,
                }),
            ),
            put(setVoting2Fa(false)),
        ]);
        if (resolve) resolve();
    } catch (error: any) {
        if (error.data && error.data.message && error.data.message.startsWith('The submission voter')) {
            yield put(
                setInAppNotification({
                    message: 'Vote Already Cast',
                    title: 'Vote Already Cast',
                }),
            );
        } else {
            yield call(globalErrorHandler, error);
            SentryCapture(error, 'error');
        }
        yield put(castVoteFail(error));
        if (reject) reject();
    }
}

function* getRecommendations(): any {
    try {
        const response = yield call(api, getRecommendationUrl, httpRequest.GET, {}, 2, 2000, false);
        const { data }: { data: IContest[] } = response.data;
        yield put(getRecommendationSuccess(data));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(getRecommendationFail(error));
        yield call(globalErrorHandler, error);
    }
}

function* createBookmark({ payload }: { payload: ICreateBookmark }): any {
    try {
        const response = yield call(api, saveCollectionUrl, httpRequest.POST, payload, 1, 2000);
        const { data } = response.data;
        yield put(createBookmarkSuccess(data));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.BOOKMARK,
            }),
        );
        yield call(showToastMessage, 'Bookmark Sucessful', 'success');
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(createBookmarkFail({ ...error, documentId: payload.details.model, additionalPayload: payload }));
        yield call(globalErrorHandler, error);
    }
}

function* deleteBookmark({ payload }: { payload: IGenericDocumentModifier }): any {
    try {
        yield call(api, `${saveCollectionUrl}/${payload.documentId}`, httpRequest.DELETE, payload, 1, 2000);
        yield put(deleteBookmarkSuccess(payload));
        yield put(
            destroyOneCache({
                cacheType: CACHE_TYPE.BOOKMARK,
            }),
        );
        yield call(showToastMessage, 'Bookmark Removed Successfully', 'info');
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(deleteBookmarkFail({ ...error, documentId: payload.documentId, additionalPayload: payload }));
        yield call(globalErrorHandler, error);
    }
}

function* getBookmarks({
    payload,
    resolve,
    reject,
}: {
    payload: IGetSavedCollections;
    resolve: (data: IGetAllResponse<IBookmark[]>) => void;
    reject: (error: any) => void;
}): any {
    const params = new URLSearchParams();
    if (payload.type) params.append('type', String(payload.type));
    if (payload.page) params.append('page', String(payload.page));
    if (payload.limit) params.append('limit', String(payload.limit));
    const defaultUseCache = yield* isUseCacheEnabled();
    const defaultCacheDuration = yield* getCacheDuration();
    let initialResult: any = null;
    const cache: CacheValue = yield* getCacheByType(CACHE_TYPE.BOOKMARK);
    if (cache && cache.key) {
        initialResult = cache.value;
    }
    if (
        !!initialResult &&
        defaultUseCache &&
        ((Date.now() - Number(cache.key)) as unknown as number) < defaultCacheDuration
    ) {
        yield put(getBookmarkSuccess(initialResult));
        if (resolve) {
            resolve(
                //@ts-ignore
                {
                    currentPage: initialResult.currentPage,
                    data: { data: initialResult.data },
                    pageSize: initialResult.pageSize,
                    status: initialResult.status,
                    totalCount: initialResult.totalCount,
                    totalPages: initialResult.totalPages,
                },
            );
        }
    } else {
        try {
            const response = yield call(api, getSavedCollectionUrl, httpRequest.GET, null, 0, 0);
            const { data } = response.data;
            yield put(getBookmarkSuccess(data));
            yield put(
                setCache({
                    key: Date.now(),
                    type: CACHE_TYPE.BOOKMARK,
                    value: data,
                    isUnique: true,
                }),
            );
            if (resolve) {
                resolve(
                    //@ts-ignore
                    {
                        currentPage: response.currentPage,
                        data: { data: response.data },
                        pageSize: response.pageSize,
                        status: response.status,
                        totalCount: response.totalCount,
                        totalPages: response.totalPages,
                    },
                );
            }
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getBookmarkFail(error));
            if (reject) {
                reject(error);
            }
        }
    }
}

function* getMySubmissions({
    payload,
    resolve,
    reject,
}: {
    payload: IGetSubmissions;
    resolve: (data: IGetAllResponse<ISubmission[]>) => void;
    reject: (error: any) => void;
}): any {
    const params = new URLSearchParams();
    if (payload.phase) params.append('phase', String(payload.phase));
    if (payload.page) params.append('page', String(payload.page));
    if (payload.limit) params.append('limit', String(payload.limit));
    const defaultUseCache = yield* isUseCacheEnabled();
    const defaultCacheDuration = yield* getCacheDuration();
    let initialResult: any = null;
    const cache: NotUniqueCacheValue = yield* getCacheByType(CACHE_TYPE.USER_SUBMISSIONS);
    if (cache && cache.key) {
        initialResult = cache.value;
    }
    if (
        !!initialResult &&
        defaultUseCache &&
        ((Date.now() - Number(cache.key)) as unknown as number) < defaultCacheDuration
    ) {
        yield put(getMySubmissionsSuccess(initialResult));
        if (resolve) {
            resolve(
                //@ts-ignore
                {
                    currentPage: initialResult.currentPage,
                    data: { data: initialResult.data },
                    pageSize: initialResult.pageSize,
                    status: initialResult.status,
                    totalCount: initialResult.totalCount,
                    totalPages: initialResult.totalPages,
                },
            );
        }
    } else {
        try {
            const response = yield call(api, `${getMySubmissionsUrl}?${params}`, httpRequest.GET, {}, 2, 2000, false);
            const { data }: { data: ISubmission[] } = response;
            yield put(getMySubmissionsSuccess(data));
            yield setCache({
                key: Date.now(),
                type: CACHE_TYPE.USER_SUBMISSIONS,
                value: data,
                isUnique: true,
            });
            if (resolve) {
                resolve(
                    //@ts-ignore
                    {
                        currentPage: response.currentPage,
                        data: { data: response.data },
                        pageSize: response.pageSize,
                        status: response.status,
                        totalCount: response.totalCount,
                        totalPages: response.totalPages,
                    },
                );
            }
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getMySubmissionsFail(error));
            if (reject) {
                reject(error);
            }
        }
    }
}

function* submitProject({ payload, resolve, reject }: { payload: ISubmitProject; resolve: any; reject: any }): any {
    try {
        const state: RootState = yield select();
        const { contest }: { contest: IContestInitialState } = state;
        const categoryId = resolveSubmissionCategoryId(contest, payload.category);
        const payloadClone: ISubmitProject = {
            ...payload,
            ...(categoryId ? { category: categoryId } : {}),
        };
        const response = yield call(api, submissionsUrl, httpRequest.POST, payloadClone, 0, 0, false);
        const { data }: { data: ISubmission } = response.data;
        if (resolve) {
            resolve(data);
        }
        yield put(submitProjectSuccess(data));
        yield call(showToastMessage, 'Submission Successful', 'success');
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_SUBMISSIONS }));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_PROJECTS }));
        if (payload.isHostSubmission) {
            yield put(destroyOneCache({ cacheType: CACHE_TYPE.UNSUBMITTED_PROJECTS }));
        }
        yield put(refreshUserDashboard());
        yield put(setCategoryForSubmission(undefined));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        if (reject) {
            reject(error);
        }
        yield put(submitProjectFail(error));
        yield put(setCategoryForSubmission(undefined));
    }
}

function* completeSubmissionPaymentSaga({
    payload,
    resolve,
    reject,
}: {
    payload: ICompleteSubmissionPayment;
    resolve?: (data: unknown) => void;
    reject?: (error: unknown) => void;
}): any {
    try {
        const response = yield call(
            api,
            `${submissionsUrl}/${payload.submissionId}/complete-payment`,
            httpRequest.POST,
            { saleId: payload.saleId },
            0,
            0,
            false,
        );
        const { data } = response.data;
        const submission: ISubmission = data?.submission ?? data;
        if (resolve) resolve(data);
        yield put(completeSubmissionPaymentSuccess(submission));
        yield call(showToastMessage, 'Payment recorded. Your entry is now paid.', 'success');
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_SUBMISSIONS }));
        yield put(refreshUserDashboard());
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        if (reject) reject(error);
        yield put(completeSubmissionPaymentFail(error));
    }
}

function* requestSubmissionPaymentSaga({
    payload,
    resolve,
    reject,
}: {
    payload: IRequestSubmissionPayment;
    resolve?: (data: unknown) => void;
    reject?: (error: unknown) => void;
}): any {
    try {
        const response = yield call(
            api,
            `${submissionsUrl}/request-payment/${payload.contestId}`,
            httpRequest.POST,
            { submissionIds: payload.submissionIds },
            0,
            0,
            false,
        );
        const { data } = response.data;
        if (resolve) resolve(data);
        yield put(requestSubmissionPaymentSuccess({ notified: data?.notified ?? 0 }));
        yield call(showToastMessage, `Payment request sent to ${data?.notified ?? 0} entrant(s).`, 'success');
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        if (reject) reject(error);
        yield put(requestSubmissionPaymentFail(error));
    }
}

function* rescindSubmission({ payload }: { payload: ISubmission }): any {
    try {
        yield call(api, `${submissionsUrl}/${payload._id}`, httpRequest.DELETE, payload, 2, 2000, false);
        yield put(rescindSubmissionSuccess(payload));
        yield call(showToastMessage, 'Submission Withdrawn', 'success');
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_SUBMISSIONS }));
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_PROJECTS }));
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(rescindSubmissionFail(error));
    }
}

function* updateSubmission({
    payload,
    resolve,
    reject,
}: {
    payload: IUpdateSubmission;
    resolve: (data: ISubmission) => Promise<void>;
    reject: (reason: any) => Promise<void>;
}): any {
    try {
        const { submissionId, submission_picture, testimonial_video, ...updateData } = payload;
        let uploadedImagePath;

        // Handle file upload if submission_picture is a File
        if (submission_picture instanceof File) {
            uploadedImagePath = yield call(uploadFilesSaga as any, {
                payload: {
                    collection: 'submissions',
                    directory: 'awards',
                    path: 'image',
                    files: [submission_picture],
                    id: submissionId,
                },
            });

            // Update the submission with the uploaded file path
            if (uploadedImagePath && uploadedImagePath.length > 0) {
                updateData.submission_picture = uploadedImagePath[0];
            }
        } else if (submission_picture) {
            // If it's already a string path, use it directly
            updateData.submission_picture = submission_picture;
        }

        // Handle testimonial_video as project ID
        if (testimonial_video) {
            // testimonial_video is now a project ID, not a file
            updateData.testimonial_video = testimonial_video;
        }

        const response = yield call(
            api,
            `${submissionsUrl}/${submissionId}`,
            httpRequest.PATCH,
            updateData,
            2,
            2000,
            false,
        );
        const { data } = response.data;
        yield put(updateSubmissionSuccess(data));
        if (resolve) resolve(data);
        yield call(showToastMessage, 'Submission Updated Successfully', 'success');
        yield put(destroyOneCache({ cacheType: CACHE_TYPE.USER_SUBMISSIONS }));
    } catch (error: any) {
        SentryCapture(error, 'error');
        console.log(error);
        yield put(updateSubmissionFail(error));
        if (reject) reject(error);
        yield call(showToastMessage, 'Failed to update submission', 'error');
    }
}

function* getContest({ payload }: { payload: IGetContestPayload }): any {
    const defaultUseCache = yield* isUseCacheEnabled();
    const selectedUrl = payload.isEvent ? getContestWithContestIdUrl : getContestUrl;
    let initialResult: any = null;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(CACHE_TYPE.CONTEST, payload.contestId);
    if (cache && cache.key) {
        initialResult = cache.value;
    }
    if (initialResult && defaultUseCache) {
        yield put(getContestSuccess({ data: initialResult }));
    } else {
        try {
            const response = yield call(
                api,
                `${selectedUrl}/${payload.contestId}${payload.params ? payload.params : ''}`,
                httpRequest.GET,
                null,
                2,
                1000,
            );
            const { data } = response.data || {};
            const parsedResponse = data;
            yield put(getContestSuccess({ data: data }));

            if (payload.params) {
                /** If there is payload then clear search suggestion. Currently the payload being passed is ?search=true
                 * This should reset our search suggestion to get the most recent search result when the search box is tapped
                 * again
                 *
                 * TODO: Check for that params is specifically for search
                 */
                yield put(destroyOneCache({ cacheType: CACHE_TYPE.SEARCH_SUGGESTION }));
            }
            yield put(
                setCache({
                    key: payload.contestId,
                    value: parsedResponse,
                    type: CACHE_TYPE.CONTEST,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield call(globalErrorHandler, error);
            yield put(getContestFail(error));
        }
    }
}
/** Mind the s in thie spelling as in GetContests with an S
 * This will also return similar contests and recommendations
 */
function* getAllContests({ payload }: { payload: IGetContests }): any {
    const defaultUseCache = yield* isUseCacheEnabled();
    let initialResult: any = null;
    const cache: NotUniqueCacheValue = yield* getNotUniqueCacheByKey(
        CACHE_TYPE.CONTEST,
        (payload.params as string) ?? Date.now(),
    );
    if (cache && cache.key) {
        initialResult = cache.value;
    }
    if (initialResult && defaultUseCache) {
        yield put(getContestsSuccess({ data: initialResult, isFilitered: !!payload.params }));
    } else {
        try {
            const response = yield call(api, `${getContestUrl}${payload.params}`, httpRequest.GET, null, 2, 1000);
            const { data } = response.data;
            yield put(getContestsSuccess({ data: data, isFilitered: !!payload.params }));
            yield put(
                setCache({
                    key: payload.params ?? Date.now(),
                    value: data,
                    type: CACHE_TYPE.CONTEST,
                    isUnique: false,
                }),
            );
        } catch (error: any) {
            SentryCapture(error, 'error');
            yield put(getContestsFail(error));
        }
    }
}

/**
 * Saga to fetch contest submissions
 * @param param0
 */
function* getContestSubmissionsData({
    payload,
    resolve,
    reject,
}: {
    payload: IGetContestSubmissions;
    resolve: any;
    reject: any;
}): Generator<any, any, any> {
    try {
        const { contestId, page = 1, limit = 9, searchTerm, sort, order } = payload;

        // Build the query parameters
        const queryParams = new URLSearchParams();
        if (page) queryParams.append('page', String(page));
        if (limit) queryParams.append('limit', String(limit));
        if (searchTerm) queryParams.append('searchTerm', searchTerm);
        if (sort) queryParams.append('sort', sort);
        if (order) queryParams.append('order', order);

        // Construct the URL
        const url = `${submissionsUrl}/${contestId}/entries?${queryParams.toString()}`;

        // Call the API
        const response = yield call(api, url, httpRequest.GET, null, 2, 1000);

        yield put(getContestSubmissionsSuccess(response));
        if (resolve) resolve(response);
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield put(getContestSubmissionsFail(error));
        yield call(globalErrorHandler, error);
        if (reject) reject(error);
    }
}

interface ContestManager extends Action {
    payload: IGetManageCampiagn;
    resolve?: (response: any) => Promise<void>;
    reject?: (reason: any) => Promise<void>;
}

function* getContestManageSaga({ payload, resolve, reject }: ContestManager): Generator<any, void, any> {
    try {
        const { contestId, ...rest } = payload;

        const queryParams = Object.entries(rest)
            .filter(([, value]) => value !== undefined && value !== null && value !== '')
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`)
            .join('&');

        const request = `${getContestUrl}/${contestId}/manage${queryParams ? `?${queryParams}` : ''}`;

        const response = yield call(api, request, 'GET', null);
        const { data } = response;
        yield put(getContestManageSuccess(data));
        if (resolve) resolve(response);
    } catch (error: any) {
        yield put(getContestManageFail(error));
        if (reject) {
            const message =
                error?.message ||
                error?.response?.data?.message ||
                (typeof error === 'string' ? error : 'Failed to load campaign');
            reject(error instanceof Error ? error : new Error(message));
        }
    }
}
// Video Management Sagas
function* getPreselectionSubmissionsSaga({ payload }: { payload: IGetPreselectionSubmissions }): any {
    try {
        const {
            contestId,
            page = 1,
            limit = 10,
            category,
            searchTerm,
            selection_state,
            selection_email_sent,
            pre_selection_completed,
            sort = 'total_average',
            order = 'desc',
        } = payload;

        const queryParams = new URLSearchParams();
        queryParams.append('page', page.toString());
        queryParams.append('limit', limit.toString());
        queryParams.append('sort', sort);
        queryParams.append('order', order);

        if (category && category.length > 0) {
            category.forEach(cat => queryParams.append('category', cat));
        }

        if (searchTerm) {
            queryParams.append('searchTerm', searchTerm);
        }

        if (selection_state) {
            queryParams.append('selection_state', selection_state);
        }

        if (selection_email_sent !== undefined && selection_email_sent !== '') {
            queryParams.append('selection_email_sent', selection_email_sent.toString());
        }

        if (pre_selection_completed !== undefined && pre_selection_completed !== '') {
            queryParams.append('pre_selection_completed', pre_selection_completed.toString());
        }

        const url = `${submissionsUrl}/preselection/${contestId}?${queryParams.toString()}`;
        const response = yield call(api, url, httpRequest.GET, null);

        yield put(getPreselectionSubmissionsSuccess(response));
    } catch (error: any) {
        yield put(getPreselectionSubmissionsFail(error));
    }
}

function* preselectSubmissionsSaga({ payload }: { payload: IPreselectSubmissions }): any {
    try {
        const { contestId, submissionIds, selection_state } = payload;

        const url = `${submissionsUrl}/preselect`;
        const response = yield call(api, url, httpRequest.POST, {
            contestId,
            submissionIds,
            selection_state,
        });

        yield put(preselectSubmissionsSuccess(response));

        // Refresh the submissions list to get updated selection states
        // yield put(getPreselectionSubmissions({ contestId }));

        // Show success message
        yield put(
            setInAppNotification({
                title: 'Success',
                message: `Submissions ${selection_state === 'selected' ? 'selected' : 'deselected'} successfully`,
            }),
        );
    } catch (error: any) {
        yield put(preselectSubmissionsFail(error));

        // Show error notification
        yield put(
            setInAppNotification({
                title: 'Error',
                message: 'Failed to update submission selection',
            }),
        );
    }
}

function* sendSelectionEmailSaga({ payload }: { payload: ISendSelectionEmail }): any {
    try {
        const { contestId, submissionIds, subject, message } = payload;

        const requestBody = {
            submissionIds,
            subject: subject || 'Contest Selection Notification',
            message: message || 'Your video has been selected for the contest.',
        };

        const url = `${submissionsUrl}/preselect/email/${contestId}`;
        const data = yield call(api, url, httpRequest.POST, requestBody);

        yield put(sendSelectionEmailSuccess(data));

        // Show success notification
        yield put(
            setInAppNotification({
                title: 'Success',
                message: `Email sent successfully for ${submissionIds.length} selected video${
                    submissionIds.length > 1 ? 's' : ''
                }`,
            }),
        );
    } catch (error: any) {
        yield put(sendSelectionEmailFail(error));
        yield call(globalErrorHandler, error);
        // Show error notification
        yield put(
            setInAppNotification({
                title: 'Error',
                message: 'Failed to send selection email',
            }),
        );
    }
}

interface TaskAction extends Action {
    payload: ICreateContestPayload;
}

interface Modifier extends Action {
    payload: IGenericDocumentModifier;
}

interface ContestFetcher extends Action {
    payload: IGetUserContest;
}

interface HostCreator extends Action {
    payload: ICreateHost;
}

interface PartnerCreator extends Action {
    payload: ICreatePartner;
}

interface HostGetter extends Action {
    payload: IGetHost;
}

interface AllHostGetter extends Action {
    payload: IGetAllHosts;
}

interface AllPartnerGetter extends Action {
    payload: IGetAllPartners;
}

interface PartnerGetter extends Action {
    payload: IGetPartner;
}

interface HostSearch extends Action {
    payload: ISearchPayload;
}

interface AwardCatgeory extends Action {
    payload: ICreateAwardCategory;
}

interface ContestReference extends Action {
    payload: string[];
}

interface UnsubmittedProjects extends Action {
    payload: IGetUnsubmittedProjects;
}
interface GetS3Images extends Action {
    payload?: IGetS3ImagesPayload;
}

interface IDeleter extends Action {
    payload: IGenericDocumentModifier;
}

function* deleteAwardCategoryWatcher() {
    yield takeLatest<IDeleter>(types.DELETE_AWARD_CATEGORY, deleteAwardCategory);
}

function* getContestReferencesWatcher() {
    yield takeLatest<ContestReference>(types.GET_CONTEST_REFERENCES, getContestReferences);
}

function* getRecommendationsWatcher() {
    yield takeLatest(types.GET_RECOMMENDATION, getRecommendations);
}

function* getBookmarksWatcher() {
    yield takeLatest<any>(types.GET_BOOKMARK, getBookmarks);
}

function* submitProjectWatcher() {
    yield takeLatest<any>(types.SUBMIT_PROJECT, submitProject);
}

function* completeSubmissionPaymentWatcher() {
    yield takeLatest<any>(types.COMPLETE_SUBMISSION_PAYMENT, completeSubmissionPaymentSaga);
}

function* requestSubmissionPaymentWatcher() {
    yield takeLatest<any>(types.REQUEST_SUBMISSION_PAYMENT, requestSubmissionPaymentSaga);
}

function* getMySubmisisonsWatcher() {
    yield takeLatest<any>(types.GET_MY_SUBMISSIONS, getMySubmissions);
}

function* getContestWatcher() {
    yield takeLatest<any>(types.GET_CONTEST, getContest);
}

function* getContestsWatcher() {
    yield takeLatest<any>(types.GET_CONTESTS, getAllContests);
}

function* rescindSubmissionWatcher() {
    yield takeLatest<any>(types.RESCIND_SUBMISSION, rescindSubmission);
}

function* updateSubmissionWatcher() {
    yield takeLatest<any>(types.UPDATE_SUBMISSION, updateSubmission);
}

function* initiateVoteWatcher() {
    yield takeLatest<any>(types.INITIATE_2FA_FOR_VOTE, initiateVote);
}

function* castVoteWatcher() {
    yield takeLatest<any>(types.VOTE_FOR_SUBMISSION, castVote);
}

function* createBookmarkWatcher() {
    yield takeLatest<any>(types.CREATE_BOOKMARK, createBookmark);
}
function* deleteBookmarksWatcher() {
    yield takeLatest<any>(types.DELETE_BOOKMARK, deleteBookmark);
}

function* createContestWatcher() {
    yield takeLatest<TaskAction>(types.CREATE_CONTEST, createContest);
}

function* updateContestWatcher() {
    yield takeLatest<Modifier>(types.UPDATE_CONTEST, updateContest);
}

function* provisionContestCategoriesWatcher() {
    yield takeLatest<any>(types.PROVISION_CONTEST_CATEGORIES, provisionContestCategories);
}

function* deleteContestWatcher() {
    yield takeLatest<Modifier>(types.DELETE_CONTEST, deleteContest);
}

function* createHostWatcher() {
    yield takeLatest<HostCreator>(types.CREATE_HOST, createHost);
}

function* updateHostWatcher() {
    yield takeLatest<Modifier>(types.UPDATE_HOST, updateHost);
}

function* deleteHostWatcher() {
    yield takeLatest<Modifier>(types.DELETE_HOST, deleteHost);
}

function* getHostWatcher() {
    yield takeLatest<HostGetter>(types.GET_HOST, getHost);
}

function* geAllHostWatcher() {
    yield takeLatest<AllHostGetter>(types.GET_ALL_HOSTS, getAllHost);
}

function* createPartnerWather() {
    yield takeLatest<PartnerCreator>(types.CREATE_PARTNER, createPartner);
}

function* updatePartnerWather() {
    yield takeLatest<Modifier>(types.UPDATE_PARTNER, updatePartner);
}

function* delePartnerWather() {
    yield takeLatest<Modifier>(types.DELETE_PARTNER, delePartner);
}

function* getPartnerWather() {
    yield takeLatest<PartnerGetter>(types.GET_PARTNER, getPartner);
}

function* getAllPartnersWather() {
    yield takeLatest<AllPartnerGetter>(types.GET_ALL_PARTNERS, getAllPartners);
}

function* publishContestWatcher() {
    yield takeLatest<Modifier>(types.PUBLISH_CONTEST, publishContest);
}

function* getContestFundingRequirementsWatcher() {
    yield takeLatest<any>(types.GET_CONTEST_FUNDING_REQUIREMENTS, getContestFundingRequirementsSaga);
}

function* fundContestFromWalletWatcher() {
    yield takeLatest<any>(types.FUND_CONTEST_FROM_WALLET, fundContestFromWalletSaga);
}

function* convertContestSubmissionModeWatcher() {
    yield takeLatest<any>(types.CONVERT_CONTEST_SUBMISSION_MODE, convertContestSubmissionModeSaga);
}
function* unPublishContestWatcher() {
    yield takeLatest<Modifier>(types.UNPUBLISH_CONTEST, unPublishContest);
}

function* getUserContestWatcher() {
    yield takeLatest<ContestFetcher>(types.GET_USER_CONTEST, getUserContest);
}

function* getUserContestsWatcher() {
    yield takeLatest<any>(types.GET_USER_CONTESTS, getUserContests);
}
function* searchHostWatcher() {
    yield takeLatest<HostSearch>(types.SEARCH_HOST, searchHost);
}

function* searchPartnerWatcher() {
    yield takeLatest<HostSearch>(types.SEARCH_PARTNER, searchPartner);
}

function* createAwardCategoryWatcher() {
    yield takeLatest<AwardCatgeory>(types.CREATE_AWARD_CATEGORY, createAwardCategory);
}

function* getAssignedCodesWatcher() {
    yield takeLatest<any>(types.GET_REDEEMABLE_CODE, getAssignedCodes);
}

function* assigRedeemableCodeWatcher() {
    yield takeLatest<any>(types.ASSIGN_REDEEMABLE_CODE, assignCodes);
}

function* downloadAssetWatcher() {
    yield takeLatest<any>(types.DOWNLOAD_ASSET, downloadAsset);
}

function* getAwardCategoriesWatcher() {
    yield takeLatest<any>(types.GET_AWARD_CATEGORIES_FOR_CONTEST, getAwardCategories);
}

function* getAwardPrizesWatcher() {
    yield takeLatest<any>(types.GET_AWARDED_PRIZES_FOR_CONTEST, getAwardPrizes);
}

function* awardPrizeWatcher() {
    yield takeLatest<any>(types.AWARD_PRIZE, awardMultiplePrizez);
}

function* sendConclusionEmailWatcher() {
    yield takeLatest<any>(types.SEND_WINNERS_EMAIL, sendConclusionEmail);
}

function* sendContestEmailWatcher() {
    yield takeLatest<any>(types.SEND_CONTEST_EMAIL, sendContestEmailSaga);
}
function* getContestScoreBoardWatcher() {
    yield takeLatest<any>(types.GET_ALL_SUBMISSIONS, getContestScoreBoard);
}

function* createScoreCategoryWatcher() {
    yield takeLatest<any>(types.CREATE_SCORE_CATEGORY, createScoreCategory);
}

function* getUnsubmittedProjectsWatcher() {
    yield takeLatest<UnsubmittedProjects>(types.GET_USERS_UNSUBMITTED_PROJECTS, getUnsubmittedProjects);
}

function* getS3ImagesWatcher() {
    yield takeLatest<GetS3Images>(types.GET_S3_IMAGES, getS3ImagesSaga);
}

function* getContestSubmissionsDataWatcher() {
    yield takeLatest<any>(types.GET_CONTEST_SUBMISSIONS, getContestSubmissionsData);
}

function* getContestManageWatcher() {
    yield takeLatest<any>(types.GET_MANAGE_CAMPAIGN, getContestManageSaga);
}

function* updateCampaignAwardWatcher() {
    yield takeLatest<any>(types.UPDATE_CAMPAIGN_AWARDS, updateCampaignAwardCategories);
}

function* updateAwardCategoryWatcher() {
    yield takeLatest<any>(types.UPDATE_AWARD_CATEGORY, updateAwardCategory);
}

function* verifyProjectWatcher() {
    yield takeLatest<any>(types.VERIFY_PROJECT_SUBMISSION, verifyProject);
}
// Video Management Watchers
function* getPreselectionSubmissionsWatcher() {
    yield takeLatest<any>(types.GET_PRESELECTION_SUBMISSIONS, getPreselectionSubmissionsSaga);
}

function* preselectSubmissionsWatcher() {
    yield takeLatest<any>(types.PRESELECT_SUBMISSIONS, preselectSubmissionsSaga);
}

function* sendSelectionEmailWatcher() {
    yield takeLatest<any>(types.SEND_SELECTION_EMAIL, sendSelectionEmailSaga);
}

export default function* contestSaga() {
    yield all([
        assigRedeemableCodeWatcher(),
        awardPrizeWatcher(),
        castVoteWatcher(),
        createAwardCategoryWatcher(),
        createBookmarkWatcher(),
        createContestWatcher(),
        createHostWatcher(),
        createPartnerWather(),
        createScoreCategoryWatcher(),
        delePartnerWather(),
        deleteAwardCategoryWatcher(),
        deleteBookmarksWatcher(),
        deleteContestWatcher(),
        deleteHostWatcher(),
        downloadAssetWatcher(),
        geAllHostWatcher(),
        updateCampaignAwardWatcher(),
        updateAwardCategoryWatcher(),
        getAllPartnersWather(),
        getAssignedCodesWatcher(),
        getAwardCategoriesWatcher(),
        getAwardPrizesWatcher(),
        getBookmarksWatcher(),
        getContestReferencesWatcher(),
        getContestScoreBoardWatcher(),
        getContestsWatcher(),
        getContestWatcher(),
        getHostWatcher(),
        getMySubmisisonsWatcher(),
        getPartnerWather(),
        getPreselectionSubmissionsWatcher(),
        getRecommendationsWatcher(),
        getS3ImagesWatcher(),
        getUnsubmittedProjectsWatcher(),
        getUserContestsWatcher(),
        getUserContestWatcher(),
        initiateVoteWatcher(),
        publishContestWatcher(),
        getContestFundingRequirementsWatcher(),
        fundContestFromWalletWatcher(),
        convertContestSubmissionModeWatcher(),
        rescindSubmissionWatcher(),
        updateSubmissionWatcher(),
        searchHostWatcher(),
        searchPartnerWatcher(),
        sendConclusionEmailWatcher(),
        sendContestEmailWatcher(),
        sendSelectionEmailWatcher(),
        submitProjectWatcher(),
        completeSubmissionPaymentWatcher(),
        requestSubmissionPaymentWatcher(),
        unPublishContestWatcher(),
        updateContestWatcher(),
        provisionContestCategoriesWatcher(),
        updateHostWatcher(),
        updatePartnerWather(),
        getContestSubmissionsDataWatcher(),
        getContestManageWatcher(),
        verifyProjectWatcher(),
        preselectSubmissionsWatcher(),
    ]);
}
